var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 9.02501C12.1335 9.02501 12.2625 9.05001 12.3872 9.10001C12.5125 9.15001 12.6169 9.21668 12.7002 9.30001L17.3002 13.9C17.4835 14.0833 17.5752 14.3167 17.5752 14.6C17.5752 14.8833 17.4835 15.1167 17.3002 15.3C17.1169 15.4833 16.8835 15.575 16.6002 15.575C16.3169 15.575 16.0835 15.4833 15.9002 15.3L12.0002 11.4L8.1002 15.3C7.91686 15.4833 7.68353 15.575 7.4002 15.575C7.11686 15.575 6.88353 15.4833 6.7002 15.3C6.51686 15.1167 6.42519 14.8833 6.42519 14.6C6.42519 14.3167 6.51686 14.0833 6.7002 13.9L11.3002 9.30001C11.4002 9.20001 11.5085 9.12935 11.6252 9.08801C11.7419 9.04601 11.8669 9.02501 12.0002 9.02501Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarretUp);
export default __webpack_public_path__ + "static/media/carret-up.ab6f8843e70624b7baa5d75fd7d45e3c.svg";
export { ForwardRef as ReactComponent };